import { POWER_PERIODS } from '@/constants/supplyRates'

const present = (...candidates) => {
  for (const candidate of candidates) {
    if (candidate !== null && candidate !== undefined && String(candidate).trim() !== '') return String(candidate)
  }
  return '-'
}

export const formatCommunityContractDate = (value, pending = '-') => {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/)
  return match ? `${match[3]}/${match[2]}/${match[1]}` : pending
}

/**
 * Vista canónica del contrato de una comunidad. Los datos antiguos pueden
 * guardar la ubicación o los datos fiscales en la comunidad; los contratos
 * nuevos los guardan en cada suministro. El detalle admite ambas formas sin
 * mezclar datos de inmuebles con este circuito.
 */
export const communitySupplyDetail = (supply, pending = '-') => {
  const property = supply?.property || {}

  return {
    property: present(property.name),
    company: present(supply?.company),
    cups: present(supply?.cups),
    address: present(supply?.address, property.address),
    postal_code: present(supply?.postal_code, property.postal_code),
    municipality: present(supply?.municipality, property.municipality),
    province: present(supply?.province, property.province),
    rate: present(supply?.rate),
    iban: present(supply?.iban, property.iban),
    cif: present(supply?.cif, property.cif),
    contract_expiration: formatCommunityContractDate(supply?.contract_expiration, pending),
    powers: Object.fromEntries(POWER_PERIODS.map((period) => [period, present(supply?.[period])])),
  }
}
